// extracted by mini-css-extract-plugin
module.exports = {"shareButtons":"ShareButtons_shareButtons__1exm-","download":"ShareButtons_download__3RnmJ"};